import IcalIntegrationsPage from "./IcalIntegrationsPage";

export default IcalIntegrationsPage;
